<template>
  <div>
    <!-- filtre -->
    <v-expansion-panels v-model="panelState">
      <v-expansion-panel>
        <v-expansion-panel-header><h3><v-icon left>mdi-filter</v-icon>Filtres</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-combobox label="Type de contrat" prepend-icon="mdi-book-outline" v-model="filtreTypeContrat" :items="typesContrat" item-text="libelle" item-value="id" multiple dense></v-combobox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-combobox label="Commune" prepend-icon="mdi-map-marker" v-model="filtreCommune" :items="$store.getters['offreEmploi/communes']"  item-text="libelle" item-value="id" multiple dense></v-combobox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-combobox label="Secteur d'activité" prepend-icon="mdi-domain" v-model="filtreSecteurActivite" :items="secteurActivite" item-text="libelle" item-value="id" multiple dense></v-combobox>
                </v-col>
              </v-row>
              
              <v-row>
                <v-col cols="12" class="text-center">
                  <v-btn @click="onClearFilter" class="btn-effacer"><v-icon left>mdi-close</v-icon>Effacer</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- datatable -->
    <v-card class="mt-5">
      <v-card-title>
        Stages et contrats disponibles ({{ nbOffre | pluriel }})
      </v-card-title>
      <v-data-table class="row-pointer" :headers="headers" :footer-props="footerProps" :items="$store.getters['offreEmploi/items']" :items-per-page="itemsPerPage" dense loading-text="Chargement..." :loading="loading" @click:row="onClickRow" @pagination="onPagination">
        
      </v-data-table>
    </v-card>
  </div>
</template>

<script>


const MIN_ITEMSPERPAGE = 10
const MAX_ITEMSPERPAGE = 20

export default {
  data () {
    return {
      itemsPerPage: MIN_ITEMSPERPAGE, // Nombre de ligne de la dataTable
      headers: [
        { text: 'Offre', align: 'start', sortable: false, value: 'libelle' },
        { text: 'Commune', value: 'ville' },
        { text: 'Type de contrat', value: 'typeContrat' },
        { text: 'Secteur activité', value: 'secteurActivite' }
,
      ],
      footerProps       : { itemsPerPageOptions: [MIN_ITEMSPERPAGE, MAX_ITEMSPERPAGE, -1] },
      //id                : 0, // Id de l'offre demandé lors de l'affichage de la fiche
      loading           : true, // Indicateur de chargement
      typesContrat         : [],   // Catalogue types de contrat
      secteurActivite      : [],   // Catalogue secteur d'activité
      communes          : [],   // Liste des communes
      nbOffre           : 0,    // Nombre d'offres actuellement dans la datatable
    }
  },
  mounted(){
    var that = this
    document.title = "Bourse à l'emploi"

    this.loading = true

    Promise.all([
      this.$store.dispatch('offreEmploi/listeCommune'), // Télécharge les communes
      this.$store.dispatch('filedata/liste', {'DescId': '12315', 'bien': '0', 'emploi' : '1'}), // Télécharge le catalogue type de contrat
      this.$store.dispatch('filedata/liste', {'DescId': '12427', 'bien': '0', 'emploi' : '1'}), // Télécharge le catalogue secteur d'activité
    ])
    .then(function(){
      that.loading      = false
      that.communes     = that.$store.getters['offreEmploi/communes']
      that.typesContrat    = that.$store.getters['filedata/catalogues'](12315)
      that.secteurActivite = that.$store.getters['filedata/catalogues'](12427)
      //that.offres       = that.$store.getters['offreEmploi/items']
    })
  },
  /**
  * Rappel VueJS
  * Une computed est appelée à chaque fois qu'une des data, sur laquelle elle repose, change
  * On utilise cette fonctionnalité pour mettre à jour la liste des offres à chaque fois qu'un filtre change
  */
  computed : {
    /**
     * En général, on connecte les v-model à des données du composant
     * Ici on passe par des computed pour connecter ces v-model directement au state
     * ce qui permet de les garder en mémoire même si on change d'écran
     */    
    panelState            : { get(){ return this.$store.getters['offreEmploi/panelState']            }, set(Value){ this.$store.commit('offreEmploi/panelState'           , Value) }},
    filtreCommune         : { get(){ return this.$store.getters['offreEmploi/filtreCommune']         }, set(Value){ this.$store.commit('offreEmploi/filtreCommune'        , Value); this.$store.commit('offreEmploi/idCrypte', ""); this.$store.dispatch('offreEmploi/liste') }},
    filtreTypeContrat     : { get(){ return this.$store.getters['offreEmploi/filtreTypeContrat']     }, set(Value){ this.$store.commit('offreEmploi/filtreTypeContrat'    , Value); this.$store.commit('offreEmploi/idCrypte', ""); this.$store.dispatch('offreEmploi/liste')  }},
    filtreSecteurActivite : { get(){ return this.$store.getters['offreEmploi/filtreSecteurActivite'] }, set(Value){ this.$store.commit('offreEmploi/filtreSecteurActivite', Value); this.$store.commit('offreEmploi/idCrypte', ""); this.$store.dispatch('offreEmploi/liste') }},
    
  },
  methods : {
    /**
     * Efface les filtres saisis
     */
    onClearFilter(){
      this.filtreSecteurActivite  = []
      this.filtreTypeContrat      = []
      this.filtreCommune          = []
    },
    /**
     * Redirige vers la fiche choisie
     */
    onClickRow(Item){
      this.$router.push('/ficheemploi/' + Item.idCrypte)
    },
    /**
     * Se déclenche si le contenu de la datatable change
     */
    onPagination(Data){
      this.nbOffre = Data.itemsLength
    },
  },
  watch: {
  /**
   * Détecte si le panneau de filtre est affiché ou non
   * On adapte alors le nombre de ligne de la datatable
   */
   panelState(Old, New){
      this.itemsPerPage = New == 0 ? MAX_ITEMSPERPAGE : MIN_ITEMSPERPAGE
    }
  },
  /**
   * Les filtres en VueJS permettent de formatter une donnée avant de l'afficher
   */
  filters: {
    pluriel: Value => Value > 1 ? Value + ' résultats' : Value + ' résultat',
  }
}
</script>



<style scoped>

 

  .row-pointer >>> tbody tr :hover {
    cursor: pointer;
  }

</style>